import { Linkedin, Phone, MapPin } from 'lucide-react';
import { CLUTCH_URL, PHONE_DISPLAY, PHONE_TEL, ADDRESS, MAPS_URL, GOOGLE_BUSINESS_URL } from '../../constants';
import { ClutchLogo } from '../ClutchLogo';

export const RedesignFooter = () => (
  <footer className="footer">
    <div className="container footer-inner">
      <nav className="foot-legal foot-nav" data-testid="footer-services-links" aria-label="Services">
        <a href="/services/bi-dashboards" data-testid="footer-bi-link">BI &amp; Dashboards</a>
        <span aria-hidden="true">|</span>
        <a href="/services/tableau-consulting" data-testid="footer-tableau-link">Tableau</a>
        <span aria-hidden="true">|</span>
        <a href="/services/power-bi-consulting" data-testid="footer-powerbi-link">Power BI</a>
        <span aria-hidden="true">|</span>
        <a href="/services/data-strategy" data-testid="footer-strategy-link">Data Strategy</a>
        <span aria-hidden="true">|</span>
        <a href="/services/advanced-analytics" data-testid="footer-advanced-link">Analytics</a>
        <span aria-hidden="true">|</span>
        <a href="/dashboards" data-testid="footer-dashboards-link">Dashboards</a>
        <span aria-hidden="true">|</span>
        <a href="/case-studies" data-testid="footer-case-studies-link">Case Studies</a>
        <span aria-hidden="true">|</span>
        <a href="/testimonials" data-testid="footer-testimonials-link">Testimonials</a>
        <span aria-hidden="true">|</span>
        <a href="/#process" data-testid="footer-process-link">Process</a>
        <span aria-hidden="true">|</span>
        <a href="/insights" data-testid="footer-insights-link">Insights</a>
        <span aria-hidden="true">|</span>
        <a href="/analytics-assessment" data-testid="footer-assessment-link">Assessment</a>
        <span aria-hidden="true">|</span>
        <a href="/contact" data-testid="footer-contact-link">Contact</a>
      </nav>
      <img src="/pniel-logo-footer.webp" alt="Pniel Analytics" width="96" height="40" loading="lazy" style={{ height: 40 }} />
      <div className="foot-meta">
        <address className="foot-contact" data-testid="footer-contact">
          <a href={`tel:${PHONE_TEL}`} data-testid="footer-phone-link">
            <Phone className="w-4 h-4" /> {PHONE_DISPLAY}
          </a>
          <a className="foot-nap" href={MAPS_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-address">
            <MapPin className="w-4 h-4" /> {ADDRESS.city}, {ADDRESS.region} {ADDRESS.postal}
          </a>
        </address>
        <div className="foot-ids" data-testid="footer-gov-identifiers">
          <span style={{ color: '#fff' }}>DUNS:</span> 149969890 &nbsp;|&nbsp; <span style={{ color: '#fff' }}>UEI:</span> DKYJUZJSSFZ4 &nbsp;|&nbsp; <span style={{ color: '#fff' }}>CAGE:</span> 23ZH5
        </div>
      </div>
      <div className="foot-social">
        <a
          href="https://www.linkedin.com/company/pniel-analytics/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Pniel Analytics on LinkedIn"
          data-testid="footer-linkedin-link"
        >
          <Linkedin className="w-4 h-4" /> LinkedIn
        </a>
        <a
          href={CLUTCH_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Pniel Analytics reviews on Clutch"
          data-testid="footer-clutch-link"
        >
          <ClutchLogo height={13} />
        </a>
        <a
          href={GOOGLE_BUSINESS_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Find Pniel Analytics on Google"
          data-testid="footer-google-link"
        >
          <MapPin className="w-4 h-4" /> Find us on Google
        </a>
      </div>
      <nav className="foot-legal" data-testid="footer-legal-links" aria-label="Legal">
        <a href="/terms" data-testid="footer-terms-link">Terms &amp; Conditions</a>
        <span aria-hidden="true">|</span>
        <a href="/privacy" data-testid="footer-privacy-link">Privacy Policy</a>
        <span aria-hidden="true">|</span>
        <a href="/eeo" data-testid="footer-eeo-link">EEO</a>
        <span aria-hidden="true">|</span>
        <a href="/careers" data-testid="footer-careers-link">Careers</a>
        <span aria-hidden="true">|</span>
        <a href="/ada" data-testid="footer-ada-link">ADA</a>
        <span aria-hidden="true">|</span>
        <a href="/government" data-testid="footer-government-link">Government</a>
      </nav>
      <div data-testid="footer-copyright">&copy; {new Date().getFullYear()} Pniel Analytics LLC. All rights reserved.</div>
    </div>
  </footer>
);
